import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
export const importLICSchemeApi = createApi({
    reducerPath: "importLICScheme",
    baseQuery,
    tagTypes: ["importLICScheme"],
    endpoints: (builder) => ({
     
        createLICScheme: builder.mutation({
            query: ({ id,...data }) => ({
              url: `import/product/scheme/${id}`, 
              method: "PUT",
              headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
              body: { scheme:data },
            }),
            invalidatesTags: ["importLICScheme"],
          }),
          updateLICScheme: builder.mutation({
            query: ({ id,...data }) => ({
              url: `import/product/scheme/${id}`, 
              method: "PUT",
              headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
              body: { scheme:data },
            }),
            invalidatesTags: ["importLICScheme"],
          }),
          getLICSchemeId: builder.query({
            query: ({id}) => `import/product/scheme/${id}`,
            transformResponse: (response) => response?.data,
            providesTags: ["importLICScheme"],
          }), 







        })
    })
    export const {
        useCreateLICSchemeMutation,
        useUpdateLICSchemeMutation,
        useLazyGetLICSchemeIdQuery

    } = importLICSchemeApi